/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CaptchaInfo/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CaptchaInfo({
  children,
  viewPath = "/DesignSystem/CaptchaInfo",
  goTo = "https://policies.google.com/privacy"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="CaptchaInfo.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z1OUdIM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-2-Z1OUdIM': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pl-3-Z1OUdIM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1OUdIM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="This site is protected by reCAPTCHA and the Google"
/>
<div
  data-testid="CaptchaInfo.Horizontal"
  data-view-path={viewPath}
 style={{'--pb-1-Z1OUdIM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-Z1OUdIM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1OUdIM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 goTo={goTo}
 target="_blank"
 marginLeft="0.2rem"
 size="small"
 text="Privacy Policy"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="and"
 marginLeft="0.2rem"
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 goTo={goTo}
 target="_blank"
 marginLeft="0.2rem"
 size="small"
 text="Terms of Service"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="apply."
 marginLeft="0.2rem"
/>
</div>
</div>
{children}
</React.Fragment>)
}